export enum MethodEnum {
  //粘贴链接
  copyLink = 'copyLink',
  //fb分享
  facebook = 'facebook',
  //保存图片
  saveImage = 'saveImage',
  //微信好友
  WeChatSession = 'WeChatSession',
  //朋友圈
  WeChatMoments = 'WeChatMoments',
  //短信
  sms = 'sms',
  //fb聊天消息
  messenger = 'messenger',
  //更多
  more = 'more',
  //whatsapp
  whatsapp = 'whatsapp',

  Line = 'line',

  KakaoTalk = 'kakao',

  InstagramChat = 'instagram'
}
